import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body", "chevron"]

  toggle(event) {
    const index = this.headerTargets.indexOf(event.currentTarget)
    if (index === -1) return

    const body = this.bodyTargets[index]
    const chevron = this.chevronTargets[index]

    body.classList.toggle("d-none")
    chevron.style.transform = body.classList.contains("d-none") ? "" : "rotate(90deg)"
  }
}
